export function getTime(time: string) {
  return new Date(new Date().toDateString() + ' ' + time);
}
